import { Heart, HandCoins, Building2, ArrowUpRight } from "lucide-react";
import Reveal from "../components/Reveal";
import NewsletterForm from "../components/NewsletterForm";

const HELLOASSO_URL = "https://www.helloasso.com/associations/joy-messenger/collectes/soutien-a-la-creation-musicale-independante";

const WAYS = [
  {
    icon: Heart,
    title: "Adhésion",
    price: "à partir de 20 € / an",
    text: "Rejoignez l'association : accès en avant-première aux sorties, invitations aux sessions et tarifs préférentiels sur la boutique.",
    cta: "Adhérer",
    subject: "Adhésion à l'association Joy Messenger",
  },
  {
    icon: HandCoins,
    title: "Don libre",
    price: "à partir de 1 €",
    text: "Chaque euro finance directement l'enregistrement des albums, les sessions filmées et les tournées des quatre projets.",
    cta: "Faire un don sur HelloAsso",
    url: HELLOASSO_URL,
  },
  {
    icon: Building2,
    title: "Mécénat",
    price: "entreprises & fondations",
    text: "Associez votre image à une maison de création indépendante : mécénat de production, d'édition ou de diffusion.",
    cta: "Échanger avec nous",
    subject: "Mécénat — Joy Messenger",
  },
];

export default function Support() {
  return (
    <main data-testid="support-page" className="pt-28 sm:pt-36">
      <div className="jm-container pb-24 sm:pb-32">
        <Reveal>
          <p className="jm-overline mb-5">Soutenir</p>
          <h1 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl text-jm-bone leading-[1.08] max-w-3xl">
            Devenez passeur de <em className="italic text-jm-brass">musique libre</em>
          </h1>
          <p className="mt-6 max-w-2xl text-jm-smoke leading-relaxed">
            Joy Messenger est une association loi 1901. Sans subvention pérenne ni machine commerciale,
            la maison avance grâce à celles et ceux qui l'écoutent. Votre soutien rend chaque disque,
            chaque concert et chaque session possible.
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6" data-testid="support-ways">
          {WAYS.map((w, i) => (
            <Reveal key={w.title} delay={0.08 * i}>
              <div className="group h-full flex flex-col border border-jm-brass/15 hover:border-jm-brass/40 bg-jm-card/60 p-8 transition-colors duration-500">
                <w.icon size={26} strokeWidth={1.4} className="text-jm-amber" />
                <h2 className="mt-6 font-serif text-2xl text-jm-bone">{w.title}</h2>
                <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-jm-brass mt-2">{w.price}</p>
                <p className="mt-5 text-sm text-jm-smoke leading-relaxed flex-1">{w.text}</p>
                <a
                  href={w.url || `mailto:soutien@joymessenger.fr?subject=${encodeURIComponent(w.subject)}`}
                  {...(w.url ? { target: "_blank", rel: "noreferrer" } : {})}
                  data-testid={`support-cta-${w.title.toLowerCase().replace(/[^a-z]/g, "-")}`}
                  className="mt-8 inline-flex items-center justify-center gap-2 border border-jm-brass/40 px-5 py-3.5 text-sm text-jm-bone hover:bg-jm-amber hover:text-jm-ink hover:border-jm-amber transition-colors duration-300"
                >
                  {w.cta} <ArrowUpRight size={14} />
                </a>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <div className="mt-20 border border-jm-brass/15 bg-jm-coal/40 p-10 sm:p-14 text-center">
            <p className="jm-overline mb-4">Rester informé·e</p>
            <h2 className="font-serif text-2xl sm:text-3xl text-jm-bone mb-8">
              La lettre de la maison, une fois par mois
            </h2>
            <NewsletterForm />
          </div>
        </Reveal>
      </div>
    </main>
  );
}
